/**
 * @voltxampere/engine — B-source expression DSL barrel
 * (Sprint 54.2b-4)
 *
 * Isolated DSL for B-source `expression: string` parameter. Distinct
 * from Sprint 9 assertion DSL — that grammar models tolerance /
 * oscillation / peak which B-source doesn't need; B-source needs
 * ternary + pulse() which assertion DSL doesn't model.
 *
 * Pipeline:
 *   tokenize(source) → parseExpr(tokens) → evaluate(ast, ctx) → number
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export { tokenize } from "./lexer.js";
export { parseExpr } from "./parser.js";
export { evaluate, pulseValueAt } from "./evaluator.js";
/**
 * Convenience one-shot: source → ast. Caches the AST per
 * source string per the caller's responsibility (B-source stamp
 * caches per instance).
 */
import { tokenize } from "./lexer.js";
import { parseExpr } from "./parser.js";
export function parseSource(source) {
    return parseExpr(tokenize(source));
}
//# sourceMappingURL=index.js.map